import { CREATED_AT_PROPERTY_ID, DEFINITION_ES_PROPERTY_ID, ENTITY_DOMAIN_PROPERTY_ID, ENTITY_ID_PROPERTY_ID, ENTITY_OWNER_PROPERTY_ID, PARENT_GROUP_PROPERTY_ID, TITLE_PROPERTY_ID } from './constants';
import { PERMISSIONS_ES_PROPERTY_ID, PERMISSIONS_PROPERTY_ID, PERMISSIONS_UPDATE_ES_PROPERTY_ID } from '@hypercharge/lambda-utils/lib/constants';
//
//
// Property metadata
//
//
export var PropertyTypes;
(function (PropertyTypes) {
    PropertyTypes["text"] = "text";
    PropertyTypes["multitext"] = "multitext";
    PropertyTypes["richtext"] = "richtext";
    PropertyTypes["select"] = "select";
    PropertyTypes["date"] = "date";
    PropertyTypes["file"] = "file";
    PropertyTypes["number"] = "number";
    PropertyTypes["link"] = "link";
    PropertyTypes["entity"] = "entity";
    PropertyTypes["checkbox"] = "checkbox";
    PropertyTypes["phoneNumber"] = "phoneNumber";
    PropertyTypes["email"] = "email";
    PropertyTypes["json"] = "json";
})(PropertyTypes || (PropertyTypes = {}));
export var CRUD;
(function (CRUD) {
    CRUD["know"] = "KNOW";
    CRUD["create"] = "CREATE";
    CRUD["read"] = "READ";
    CRUD["update"] = "UPDATE";
    CRUD["delete"] = "DELETE";
})(CRUD || (CRUD = {}));
//# sourceMappingURL=types.js.map